import { render, staticRenderFns } from "./chatbotDocuments.vue?vue&type=template&id=2474b3cb&scoped=true&"
import script from "./chatbotDocuments.vue?vue&type=script&lang=ts&"
export * from "./chatbotDocuments.vue?vue&type=script&lang=ts&"
import style0 from "./chatbotDocuments.vue?vue&type=style&index=0&id=2474b3cb&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2474b3cb",
  null
  
)

export default component.exports